import React from 'react';
import { View } from '@wmfe/mach-pro-components-react';
import { appInfo } from '@/src/pages/customer_service/lib/get-enviroment';
import { replaceImageUrl, reportWarn } from '../../utils';
import './index.css';
import { EnumFaqType } from '../../type';

export default function Faq(props) {
  const {
    faqList = [],
    from,
    onFaqClick,
    unreadCount,
    orderDTO
  } = props;
  const singleLine = true; // ??? todo-why:

  if (!from) reportWarn('FaqList 缺少from');

  const isRtl = () => appInfo.isrtl;

  const showIcon = (faq: { rtlIcon: string; icon: string; }) => {
    if (isRtl()) {
      return !!faq.rtlIcon;
    } else {
      return !!faq.icon;
    }
  };
  return (
    <View className="faq-list" style={{ height: faqList?.length > 1 ? (faqList?.length * 60) + 16 : faqList?.length * 60 }}>
      {faqList?.map((faq) => (
        <View
          key={faq?.faqDisplayName}
          // style={{ borderBottom: faqList?.length > 1 ? '1px solid #e1dddd' : '' }}
          className="faq-item"
          onClick={() => {
            // 这里from多余，因为onFaqClick是从外层传过来的，外层只有一个参数，faq，这里from无用，但上线前先不删除了，避免有评估不到的风险
            onFaqClick({ ...faq, orderRegion: orderDTO?.region }, from);
          }}
        >
          <View class="faq-prefix">
            {showIcon(faq) && (
              <image
                className="faq-icon"
                src={replaceImageUrl(isRtl() ? faq.rtlIcon : faq.icon)}
              />
            )}
            <View class="faq-name" className={singleLine ? 'van-ellipsis' : 'van-multi-ellipsis--l2'}>
              <text className="faq-text">{faq?.faqDisplayName}</text>
            </View>
          </View>

          <View class="append-icon">
            { unreadCount && faq.type === EnumFaqType.Progress ? <text class="faq-tip">{ unreadCount }</text> : null}
            <image autoRTL className="right-arrow-icon-new" src="assets://newcustomerservice/right-arrow.png" />
          </View>
        </View>
      ))}
    </View>
  );
}
